// @flow
import { startOfDay, addYears, toDate, parseISO } from "date-fns";

export const SCHEDULE_CABELAS_CLASSES_FORM: string =
  "scheduleCabelasClassesForm";

// Matches MAX_IMPORTED_DATE_ROWS so manual entry and CSV import share one cap.
export const MAX_SCHEDULED_CLASS_DATES: number = 50;

export const CABELAS_BUSINESS_SLUG: string = "cabelas";

export const EVENTS_API_ENDPOINTS = {
  CREATE_EVENT: "/api/events/instructor/events",
  EVENTS: "/api/events/events",
  ALL_EVENTS: "/api/events/instructor/events",
  REVIEW_STATUS_COUNTS: "/api/events/instructor/events/review-status/counts",
  REVIEW_ACTIONS: (eventId: string): string =>
    `/api/events/events/${eventId}/review-actions`,
  EVENT_CONTENT: "/api/events/instructor/event-content",
  BUSINESS_TEMPLATES: (businessId: string): string =>
    `/api/events/businesses/${businessId}/templates`,
};

export const BIZHUB_API_ENDPOINTS = {
  INSTRUCTOR_LOCATIONS: "/api/business/instructor/locations",
  BUSINESS: (slug: string): string => `/api/business/businesses/${slug}`,
  BUSINESS_EVENTS: (slug: string): string =>
    `/api/business/businesses/${slug}/events`,
};

// Compute per call so long-lived tabs do not retain yesterday.
export const getMinClassDate = (): Date => startOfDay(new Date());
export const getMaxClassDateFor = (today: Date): Date =>
  toDate(addYears(startOfDay(today), 1));
export const getMaxClassDate = (): Date => getMaxClassDateFor(new Date());
export const MAX_CLASS_DATE_MESSAGE: string =
  "Must be within one year from today";

// Sentinel dates carry wall-clock times only.
export const DEFAULT_START_TIME: Date = toDate(parseISO("1899-12-31T09:00:00"));
export const DEFAULT_END_TIME: Date = toDate(parseISO("1899-12-31T17:00:00"));
export const DEFAULT_CLOSE_TIME: Date = toDate(parseISO("1899-12-31T23:45:00"));

export const EVENT_TIMEZONE_OPTIONS: Array<{ value: string, label: string }> = [
  { value: "US/Eastern", label: "Eastern (US/Eastern)" },
  { value: "US/Central", label: "Central (US/Central)" },
  { value: "US/Mountain", label: "Mountain (US/Mountain)" },
  { value: "America/Los_Angeles", label: "Pacific (America/Los_Angeles)" },
  { value: "US/Arizona", label: "Arizona (US/Arizona)" },
  { value: "US/Alaska", label: "Alaska (US/Alaska)" },
  { value: "Pacific/Honolulu", label: "Hawaii (Pacific/Honolulu)" },
];

export const DEFAULT_EVENT_STATUS: string = "draft";
